const FLOW_STORAGE_KEY = 'paleo_cstcloud_onboarding_v1'

export function unwrapApiData(result) {
  return (result && result.data) || result || {}
}

export function getAuthorizationUrl(result) {
  const data = unwrapApiData(result)
  return data.authorizationUrl || data.authorizeUrl || data.url || ''
}

export function isSafeAuthorizationUrl(value) {
  try {
    const url = new URL(value, window.location.origin)
    return url.protocol === 'https:' || (process.env.NODE_ENV !== 'production' && url.protocol === 'http:')
  } catch (error) {
    return false
  }
}

export function currentRelativePath(route) {
  const fullPath = route && route.fullPath ? route.fullPath : '/'
  if (!fullPath.startsWith('/') || fullPath.startsWith('//') || fullPath.startsWith('/auth/cstcloud/')) {
    return '/'
  }
  return fullPath
}

export function safeRedirectPath(value, fallback = '/') {
  const path = String(value || '').trim()
  if (!path.startsWith('/') || path.startsWith('//') || /[\\\r\n]/.test(path)) {
    return fallback
  }
  try {
    const decoded = decodeURIComponent(path)
    if (!decoded.startsWith('/') || decoded.startsWith('//') || /[\\\r\n]/.test(decoded)) {
      return fallback
    }
  } catch (error) {
    return fallback
  }
  return path.startsWith('/auth/cstcloud/') ? fallback : path
}

export function normalizeCstCloudOutcome(data) {
  return String(data.status || data.result || data.nextAction || data.action || '').trim().toUpperCase()
}

export function saveOnboardingFlow(payload) {
  sessionStorage.setItem(FLOW_STORAGE_KEY, JSON.stringify({
    ...payload,
    savedAt: Date.now()
  }))
}

export function readOnboardingFlow() {
  try {
    const flow = JSON.parse(sessionStorage.getItem(FLOW_STORAGE_KEY) || 'null')
    if (!flow || !flow.onboardingTicket || Date.now() - Number(flow.savedAt || 0) > 15 * 60 * 1000) {
      clearOnboardingFlow()
      return null
    }
    return flow
  } catch (error) {
    clearOnboardingFlow()
    return null
  }
}

export function clearOnboardingFlow() {
  sessionStorage.removeItem(FLOW_STORAGE_KEY)
}
